// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"805e4c13","977":"35b15037"}[chunkId] + ".chunk.js";
};